import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';

export default function RegrasPage() {
  const navigate = useNavigate();
  const [regras, setRegras] = useState({
    participacaoMinima: false,
    metaMinimaParticipacao: '',
    multiplicadorProgresso: false,
    bonusEquipe: false,
    percentualBonusEquipe: '',
    penalidade: false,
    tipoPenalidade: '',
    limitePontosDiario: false,
    maxPontosDia: '',
    validacaoManual: false,
    aprovacaoGestor: false
  });

  const handleToggle = (field: string) => {
    setRegras({
      ...regras,
      [field]: !regras[field as keyof typeof regras]
    });
  };

  const handleChange = (field: string, value: string) => {
    setRegras({
      ...regras,
      [field]: value
    });
  };

  const handleProximo = () => {
    navigate('/admin/incentivo/campanhas/premiacao');
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Regras da Campanha</h1>
            <p className="text-gray-600 mt-1">Configure as regras e restrições da campanha</p>
          </div>
          <button className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
            Salvar Regras
          </button>
        </div>

        {/* Progress Steps */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Dados Básicos</span>
            </div>
            <div className="flex-1 h-1 bg-emerald-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Objetivos</span>
            </div>
            <div className="flex-1 h-1 bg-emerald-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </div>
              </div>
              <span className="text-gray-600">Ações</span>
            </div>
            <div className="flex-1 h-1 bg-blue-600 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center font-semibold">
                4
              </div>
              <span className="font-semibold text-gray-900">Regras</span>
            </div>
            <div className="flex-1 h-1 bg-gray-200 mx-4"></div>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center font-semibold">
                5
              </div>
              <span className="text-gray-600">Premiação</span>
            </div>
          </div>
        </div>

        {/* Regras de Participação */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Regras de Participação</h3>
          <div className="space-y-4">
            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Participação Mínima</h4>
                <p className="text-sm text-gray-600">Exigir meta mínima para participar da premiação</p>
                {regras.participacaoMinima && (
                  <div className="mt-3">
                    <input
                      type="number"
                      value={regras.metaMinimaParticipacao}
                      onChange={(e) => handleChange('metaMinimaParticipacao', e.target.value)}
                      className="w-48 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      placeholder="% da meta"
                    />
                  </div>
                )}
              </div>
              <button
                onClick={() => handleToggle('participacaoMinima')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.participacaoMinima ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.participacaoMinima ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Aprovação do Gestor</h4>
                <p className="text-sm text-gray-600">Pontuações precisam ser aprovadas pelo gestor</p>
              </div>
              <button
                onClick={() => handleToggle('aprovacaoGestor')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.aprovacaoGestor ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.aprovacaoGestor ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Validação Manual</h4>
                <p className="text-sm text-gray-600">Ações precisam ser validadas manualmente</p>
              </div>
              <button
                onClick={() => handleToggle('validacaoManual')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.validacaoManual ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.validacaoManual ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>

        {/* Regras de Pontuação */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Regras de Pontuação</h3>
          <div className="space-y-4">
            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Multiplicador de Progresso</h4>
                <p className="text-sm text-gray-600">Pontos aumentam conforme o progresso da meta</p>
              </div>
              <button
                onClick={() => handleToggle('multiplicadorProgresso')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.multiplicadorProgresso ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.multiplicadorProgresso ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>

            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Limite de Pontos Diário</h4>
                <p className="text-sm text-gray-600">Definir limite máximo de pontos por dia</p>
                {regras.limitePontosDiario && (
                  <div className="mt-3">
                    <input
                      type="number"
                      value={regras.maxPontosDia}
                      onChange={(e) => handleChange('maxPontosDia', e.target.value)}
                      className="w-48 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      placeholder="Máximo de pontos"
                    />
                  </div>
                )}
              </div>
              <button
                onClick={() => handleToggle('limitePontosDiario')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.limitePontosDiario ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.limitePontosDiario ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>

        {/* Regras de Equipe */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Regras de Equipe</h3>
          <div className="space-y-4">
            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Bônus de Equipe</h4>
                <p className="text-sm text-gray-600">Bônus adicional quando toda equipe atinge a meta</p>
                {regras.bonusEquipe && (
                  <div className="mt-3">
                    <input
                      type="number"
                      value={regras.percentualBonusEquipe}
                      onChange={(e) => handleChange('percentualBonusEquipe', e.target.value)}
                      className="w-48 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                      placeholder="% de bônus"
                    />
                  </div>
                )}
              </div>
              <button
                onClick={() => handleToggle('bonusEquipe')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.bonusEquipe ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.bonusEquipe ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>

        {/* Regras de Penalidade */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Regras de Penalidade</h3>
          <div className="space-y-4">
            <div className="flex items-start justify-between p-4 border border-gray-200 rounded-lg">
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">Penalidade por Não Cumprimento</h4>
                <p className="text-sm text-gray-600">Aplicar penalidade para metas não atingidas</p>
                {regras.penalidade && (
                  <div className="mt-3">
                    <select
                      value={regras.tipoPenalidade}
                      onChange={(e) => handleChange('tipoPenalidade', e.target.value)}
                      className="w-64 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
                    >
                      <option value="">Selecione o tipo</option>
                      <option value="desconto">Desconto de Pontos</option>
                      <option value="exclusao">Exclusão da Premiação</option>
                      <option value="reducao">Redução de Bônus</option>
                    </select>
                  </div>
                )}
              </div>
              <button
                onClick={() => handleToggle('penalidade')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors cursor-pointer ${
                  regras.penalidade ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    regras.penalidade ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
            </div>
          </div>
        </div>

        {/* Info Box */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <div className="w-5 h-5 flex items-center justify-center mt-0.5">
              <i className="ri-information-line text-blue-600"></i>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-blue-900 mb-1">Importante</h4>
              <p className="text-sm text-blue-800">
                As regras definidas aqui serão aplicadas automaticamente durante toda a campanha. Certifique-se de configurá-las corretamente antes de ativar a campanha.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-between">
          <button className="px-6 py-2 text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            <span>Voltar: Ações e Pontos</span>
          </button>
          <button 
            onClick={handleProximo}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
          >
            <span>Próximo: Premiação</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </button>
        </div>
      </div>
    </Layout>
  );
}